import API from '../..';

export const getSystemsCatalog = ({ searchText = '' } = {}) =>
    API.get(`/bom/systems/catalog/`, {
        params: {
            search: searchText,
        },
    });

export const getPreset = (systemId) =>
    API.get(`/api/v1/users/preset/system/${systemId}/`);

export const getPresets = () => API.get(`/api/v1/users/presets-systems/`);

export const updatePreset = (data, systemId) =>
    API.patch(`/api/v1/users/preset/system/${systemId}/`, data, {
        headers: { 'Content-Type': 'application/json' },
    });
